import React, { useContext, ReactNode, useRef, RefObject } from 'react';

interface INodeContext {
    nodesRef: RefObject<Record<string, HTMLElement>> | null;
}

const NodeContext = React.createContext<INodeContext>({ nodesRef: null });

const useNodeContext = () => useContext(NodeContext);

interface NodeProviderProps {
    children?: ReactNode;
}

const NodeProvider = ({ children }: NodeProviderProps) => {
    const nodesRef = useRef<Record<string, HTMLElement>>({});

    const contextValues = {
        nodesRef,
    };

    return (
        <NodeContext.Provider value={contextValues}>
            {children}
        </NodeContext.Provider>
    );
};

export { NodeProvider as default, useNodeContext };
